var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnauthorized(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 222,
    height: 182,
    viewBox: "0 0 222 182",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 130.753V6.21821C0.25 4.09648 1.04856 1.94202 2.96983 1.04175C6.49365 -0.609459 12.1335 -0.948289 18.3393 5.00223C18.6125 5.26423 18.8628 5.55809 19.0961 5.85613C28.2171 17.5035 46.4018 21.278 58.25 11.4045C70.25 1.40451 79.25 -4.09549 93.75 7.40451C108.25 18.9045 126.75 19.9045 137.25 8.90451C147.75 -2.09549 164.75 0.404507 170.75 7.40451C176.75 14.4045 194.75 24.9045 200.75 16.9045C203.158 13.6938 207.177 10.6844 211.215 8.22991C216.052 5.29047 221.75 9.06105 221.75 14.7208V129.724C221.75 133.364 219.244 136.671 215.615 136.38C211.78 136.072 207.446 134.57 204.75 130.405C199.25 121.905 183.75 114.405 167.75 126.905C151.75 139.405 147.75 137.405 137.25 133.405C126.75 129.405 109.75 113.405 90.75 128.905C71.75 144.405 53.75 129.905 51.25 126.905C48.7837 123.945 38.045 113.686 23.3544 122.531C22.955 122.772 22.5708 123.069 22.2247 123.381C14.4835 130.365 8.90718 133.743 5.24668 135.182C2.32688 136.329 0.25 133.89 0.25 130.753Z",
    fill: "#BC99FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M111.193 181.416C136.705 181.416 157.387 179.756 157.387 177.708C157.387 175.66 136.705 174 111.193 174C85.6815 174 65 175.66 65 177.708C65 179.756 85.6815 181.416 111.193 181.416Z",
    fill: "#DECDFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M174.5 94L199 76",
    stroke: "#212129",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M187 120C194.833 119.167 210.6 117.5 211 117.5",
    stroke: "#212129",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M180.5 144.5L199 150",
    stroke: "#212129",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40 136L21.5 142",
    stroke: "#212129",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5 111L11 108",
    stroke: "#212129",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5 92.5L29 80",
    stroke: "#212129",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M149.407 87.5129H136.421V65.1776C136.421 51.2867 125.12 39.9855 111.229 39.9855C97.3384 39.9855 86.0373 51.2867 86.0373 65.1776V87.5129H73.0518V65.1776C73.0518 44.1264 90.1781 27 111.229 27C132.281 27 149.407 44.1264 149.407 65.1776V87.5129Z",
    fill: "#BC99FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M149.407 65.1779V87.5132H136.421V77.9736C139.554 74.3067 147.192 62.8067 136.921 46.8275C126.286 30.2868 107.657 29.7423 92.3643 31.9958C97.9303 28.8181 104.373 27 111.229 27C132.279 27 149.407 44.127 149.407 65.1779Z",
    fill: "#BC99FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M111.229 39.9854C97.3389 39.9854 86.0369 51.2871 86.0369 65.1774V87.5127H76.3213V82.8518C86.3749 82.852 72.9705 39.9854 111.229 39.9854Z",
    fill: "#BC99FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M151.66 158.414H70.7993C67.5969 158.414 65.001 155.818 65.001 152.616V88.6362C65.001 85.4338 67.5969 82.8379 70.7993 82.8379H151.66C154.862 82.8379 157.458 85.4338 157.458 88.6362V152.616C157.458 155.818 154.862 158.414 151.66 158.414Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M157.458 88.4236V152.83C157.458 155.913 154.956 158.415 151.873 158.415H70.5852C67.5022 158.415 65 155.913 65 152.83V144.041C66.413 146.689 69.5798 150.713 75.7628 150.713H122.346C132.71 150.713 141.11 142.313 141.11 131.949V110.318C141.11 96.6397 130.459 84.7431 117.172 82.8384H151.873C154.956 82.8384 157.458 85.3377 157.458 88.4236Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M120.566 132.536C120.981 135.146 118.966 137.507 116.325 137.507H106.133C103.492 137.507 101.477 135.146 101.892 132.536L103.342 123.441C101.16 121.358 99.8018 118.424 99.8018 115.172C99.8018 108.861 104.918 103.745 111.229 103.745C117.54 103.745 122.656 108.861 122.656 115.172C122.656 118.424 121.298 121.358 119.116 123.441L120.566 132.536Z",
    fill: "#161721"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2763 89.5547H69.6191V130.048H78.2763V89.5547Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2763 134.237H69.6191V140.939H78.2763V134.237Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M104.013 117.207C104.013 120.457 105.37 123.393 107.554 125.476L106.105 134.571C105.934 135.641 106.172 136.669 106.694 137.506H106.133C103.494 137.506 101.477 135.147 101.893 132.536L103.343 123.44C101.159 121.357 99.8018 118.425 99.8018 115.171C99.8018 108.86 104.918 103.744 111.229 103.744C113.854 103.744 116.273 104.629 118.203 106.117C117.317 105.897 116.393 105.779 115.441 105.779C109.129 105.78 104.013 110.896 104.013 117.207Z",
    fill: "#161721"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2074 61.6284C81.3198 54.9001 84.7159 44.2258 95.0319 37.8912L93.3562 34.54C93.3562 34.54 78.7634 41.9523 76.1582 61.6284H80.2074Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8775 64.4209C75.8021 65.504 75.7627 66.6208 75.7627 67.772H79.6725C79.6725 67.772 79.6368 66.492 79.8395 64.4209H75.8775Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0361 82.8381V65.1777C86.0361 51.2874 97.3379 39.9854 111.229 39.9854C125.119 39.9854 136.421 51.2871 136.421 65.1777V82.8381",
    stroke: "#161721",
    strokeWidth: 2.31146,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0508 82.8383V65.1779C73.0508 44.1273 90.178 27 111.229 27C132.279 27 149.407 44.1273 149.407 65.1779V82.8383",
    stroke: "#161721",
    strokeWidth: 2.31146,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M151.659 158.414H70.7983C67.5959 158.414 65 155.818 65 152.616V88.6362C65 85.4338 67.5959 82.8379 70.7983 82.8379H151.659C154.861 82.8379 157.457 85.4338 157.457 88.6362V152.616C157.457 155.818 154.861 158.414 151.659 158.414Z",
    stroke: "#161721",
    strokeWidth: 2.31146,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnauthorized);
export default __webpack_public_path__ + "static/media/unauthorized.7b465724a929d5f8f7f49fcacee0d2d1.svg";
export { ForwardRef as ReactComponent };